import { render, staticRenderFns } from "./HeaderEFTG.vue?vue&type=template&id=6373fea4&scoped=true"
import script from "./HeaderEFTG.vue?vue&type=script&lang=js"
export * from "./HeaderEFTG.vue?vue&type=script&lang=js"
import style0 from "./HeaderEFTG.vue?vue&type=style&index=0&id=6373fea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373fea4",
  null
  
)

export default component.exports